module.exports = __webpack_public_path__ + "img/Treasure-Annie-min.6bca2306.png";